function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import memoize from 'memoizee';
import { LoadingSpinner } from '@deephaven/components';
import { TimeUtils } from '@deephaven/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsWarning } from '@deephaven/icons';
import Code from "../common/Code.js";
import "./CommandHistoryItemTooltip.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LOAD_DATA_DEBOUNCE = 250;
var MAX_NUMBER_OF_LINES = 2500;
export class CommandHistoryItemTooltip extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "cleanup", void 0);
    _defineProperty(this, "loadData", debounce(() => {
      var _this$props = this.props,
        commandHistoryStorage = _this$props.commandHistoryStorage,
        item = _this$props.item,
        language = _this$props.language;
      var id = item.id;
      this.cleanup = commandHistoryStorage.listenItem(language, id, this.handleUpdate, this.handleError);
    }, LOAD_DATA_DEBOUNCE));
    _defineProperty(this, "getPreviewText", memoize(name => name.split('\n', MAX_NUMBER_OF_LINES).join('\n'), {
      max: 1
    }));
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleTimeout = this.handleTimeout.bind(this);
    this.state = {
      currentTime: Date.now()
    };
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps, prevState) {
    var _prevState$data;
    var data = this.state.data;
    if (this.timer == null && !(data !== null && data !== void 0 && data.result) && Boolean(data === null || data === void 0 ? void 0 : data.startTime) && !(data == null || data.endTime === undefined)) {
      this.startTimer();
    } else if (data !== null && data !== void 0 && data.result && !((_prevState$data = prevState.data) !== null && _prevState$data !== void 0 && _prevState$data.result) || Boolean(data === null || data === void 0 ? void 0 : data.endTime) && !(prevState.data == null || prevState.data.endTime === undefined)) {
      // Command complete
      this.stopTimer();
    }
  }
  componentWillUnmount() {
    this.loadData.cancel();
    if (this.cleanup != null) {
      this.cleanup();
    }
    this.stopTimer();
  }
  startTimer() {
    this.stopTimer();
    this.timer = window.setInterval(this.handleTimeout, 1000);
  }
  stopTimer() {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  updateTime() {
    this.setState({
      currentTime: Date.now()
    });
  }
  handleError(error) {
    this.setState({
      error: "".concat(error)
    });
  }
  handleUpdate(item) {
    var _ref = item !== null && item !== void 0 ? item : {},
      data = _ref.data;
    this.setState({
      data
    });
    var onUpdate = this.props.onUpdate;
    onUpdate === null || onUpdate === void 0 || onUpdate(data);
  }
  handleTimeout() {
    this.updateTime();
  }
  render() {
    var _result$error;
    var _this$props2 = this.props,
      name = _this$props2.item.name,
      language = _this$props2.language;
    var _this$state = this.state,
      currentTime = _this$state.currentTime,
      data = _this$state.data,
      error = _this$state.error;
    var _ref2 = data !== null && data !== void 0 ? data : {},
      result = _ref2.result,
      startTime = _ref2.startTime,
      endTime = _ref2.endTime;
    var errorMessage = (_result$error = result === null || result === void 0 ? void 0 : result.error) !== null && _result$error !== void 0 ? _result$error : error;
    var timeString = TimeUtils.formatConvertedDuration(startTime, endTime !== null && endTime !== void 0 ? endTime : currentTime);

    // colorizing in monaco is mostly a function of the number of lines,
    // it gets real slow after a few thousand lines. Truncate the tooltip
    // to avoid UI locks. The full command is still inserted.
    var previewText = this.getPreviewText(name);
    var hasTimeString = Boolean(timeString);
    return /*#__PURE__*/_jsxs("div", {
      className: "command-history-item-tooltip",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "scroll-container",
        children: [/*#__PURE__*/_jsx(Code, {
          language: language,
          children: previewText
        }), previewText.length < name.length && /*#__PURE__*/_jsx("p", {
          children: "Preview Truncated..."
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "result-info",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "d-flex justify-content-between",
          children: [Boolean(errorMessage) && /*#__PURE__*/_jsxs("div", {
            className: "text-danger mr-1",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsWarning
            }), " Executed with errors"]
          }), /*#__PURE__*/_jsxs("div", {
            className: "time-wrapper",
            children: ["Elapsed time:", ' ', hasTimeString ? /*#__PURE__*/_jsx("span", {
              className: "time-string",
              children: timeString
            }) : /*#__PURE__*/_jsx(LoadingSpinner, {
              className: "loading-spinner-vertical-align"
            })]
          })]
        }), Boolean(errorMessage) && /*#__PURE__*/_jsx("div", {
          className: "error-message",
          children: errorMessage
        })]
      })]
    });
  }
}
_defineProperty(CommandHistoryItemTooltip, "defaultProps", {
  onUpdate: () => undefined
});
export default CommandHistoryItemTooltip;
//# sourceMappingURL=CommandHistoryItemTooltip.js.map